export default __webpack_public_path__ + "static/media/3.72aed13a.webp";